import {OutlineDropdown} from "~/components/reusableComponents/dropdowns";
import {
    Granularity,
} from "~/modules/reports/domain/reportTypes";
import type {CanvasControls} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";
import type {EnumDictionary} from "~/typeDefinitions";
import {CanvasControlType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";

export const granularityMetadata: EnumDictionary<Granularity, {humanReadableName: string}> = {
    [Granularity.day]: {
        humanReadableName: "Day",
    },
    [Granularity.year]: {
        humanReadableName: "Year",
    },
    [Granularity.month]: {
        humanReadableName: "Month",
    },
};

export function GranularitySelector({
    selectedGranularity,
    setSelectedGranularity,
    canvasControls,
}: {
    selectedGranularity: Granularity;
    setSelectedGranularity: (item: Granularity) => void;
    canvasControls: CanvasControls;
}) {
    return (
        <OutlineDropdown
            items={[
                ...Object.entries(granularityMetadata).map(([key, value]) => ({
                    label: key,
                    value: value.humanReadableName,
                })),
                ...Object.entries(canvasControls)
                    .filter(([, value]) => value.type === CanvasControlType.granularity)
                    .map(([control, value]) => ({
                        label: `#${control}`,
                        value: value.value,
                    })),
            ]}
        />
    );
}
